import { Store as notifyStore } from "react-notifications-component";
import { NotifyContent, tempOptions } from "components/Notify";
import { exportAuditLog } from "services/auditService";
import utils from "utils";

/**
 * Exports the audit log for `request` and saves the Excel file, for the export
 * dialog and the Audit log page alike. A failed export is told to the user,
 * and so is one that brought no file (sign-in not ready): the user was told
 * the export is on its way.
 */
export default async function downloadAuditLogExport(request, t) {
  const notifyFailure = () =>
    notifyStore.addNotification({
      ...tempOptions,
      content: NotifyContent("danger", t("auditLog.exportFail")),
    });

  try {
    const { blob, fileName } = (await exportAuditLog(request)) ?? {};
    if (!blob) {
      notifyFailure();
      return;
    }
    const url = globalThis.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName || "audit-log-export.xlsx");
    document.body.appendChild(link);
    link.click();
    // The page stays open across exports: drop the link and free the file.
    link.remove();
    globalThis.URL.revokeObjectURL(url);
  } catch (error) {
    utils.debug(error, utils.MSG_TYPE_ERR);
    notifyFailure();
  }
}
